export const MirageCookies = {
    jwt: "jwt",
    sessionExpiryDate: "sessionExpiryDate",
    ad: "ad",
    adError: "ad-error",
} as const;

export type MirageCookies = typeof MirageCookies[keyof typeof MirageCookies];
